import { OverlayType } from '../DisabledModal/DisabledModal'

interface GetOverlayParams {
  isAfterpayNormalFlow: boolean
  cachedPostCheckoutEnabled: boolean
  isAfterpayAppGiftCardFlow: boolean
  isDarkMode: boolean
}

export const getOverlay = ({ isAfterpayNormalFlow, cachedPostCheckoutEnabled, isAfterpayAppGiftCardFlow, isDarkMode }: GetOverlayParams): OverlayType => {
  if (!isAfterpayNormalFlow) {
    return 'none'
  }

  const isSolid = cachedPostCheckoutEnabled || isAfterpayAppGiftCardFlow || isDarkMode

  if (isDarkMode) {
    return 'darkSolid'
  }
  return isSolid ? 'lightSolid' : 'light'
}
